import { CitizenCategoriesApi, HttpClient } from '../../../api'
import { Context } from '../../../common'
import { CitizenCategory } from '../../citizens'
import {
  CitizenCategoriesCoefficients,
  CitizenCategoriesCoefficientsService,
  CitizenCategoryCoefficient,
} from './citizenCategoriesCoefficients'

export class RemoteCitizenCategoriesCoefficientsService implements CitizenCategoriesCoefficientsService {
  private api: CitizenCategoriesApi

  constructor(httpClient: HttpClient) {
    this.api = new CitizenCategoriesApi(httpClient, undefined, '')
  }

  async get(ctx: Context): Promise<CitizenCategoriesCoefficients> {
    const result = await this.api.citizenCategoriesGetObject(ctx)
    return result.body.object
  }
  async updateByCitizenCategory(
    ctx: Context,
    citizenCategory: CitizenCategory,
    coefficient: CitizenCategoryCoefficient,
  ): Promise<void> {
    await this.api.citizenCategoryUpdate(ctx, citizenCategory, { coefficient: coefficient })
  }
}
